import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TermsConditions from "../popups/t&c";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
} from "../../common/app_constant";
import { SUB_DIRECTORY } from "../../common/constant";
import ErrorLabel from "../error_label";
import { actionLogin, resetLoginResponse } from "../../routes/app/public/store";
import { getNextScreen, numberWheelChange } from "../../utils";
import { jwtDecode } from "jwt-decode";

const EnterEmailMobile = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const { login } = useSelector((state) => ({
    ...state.publicStore,
  }));

  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      code: "axis",
      is_accepted_terms: true
    },
  });

  useDispatch(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (login !== null) {
      dispatch(resetLoginResponse());

      if (login.result === true) {
        localStorage.setItem(
          "userData",
          JSON.stringify(login.response.client_detail)
        );
        localStorage.setItem("token", JSON.stringify(login.response.token));
        const decoded = jwtDecode(login?.response?.token);
        getNextScreen(decoded?.role)
        window.location.replace("/dashboard");
        window.location.reload();
      } else {
        switch (login.status_code) {
          case 101:
            toast.error(login.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            break;
          default:
            toast.error(login.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
        }
      }
    }
  }, [login]);

  const sendLoginOTP = async (data) => {
    props.handleClose(data);
  };

  return (
    <>
      <form noValidate autoComplete="off" onSubmit={handleSubmit(sendLoginOTP)}>
        <div className="align-items-center justify-content-center justify-content-lg-start mb-3">
          <p className="lead fw-bold me-3 text-secondary">
            <span className="text-dark fw-900">Login</span><br />
            {/* <span className="cust-fs-14">Just enter your mobile number, and start saving today.</span> */}
          </p>
        </div>
        {/* mobile input */}
        <div className="form-outline mb-1">
          <label className="form-label" htmlFor="mobile">
            Mobile No.
          </label>
          <input type="hidden" name="code" value="axis"></input>
          <input
            type="number"
            id="mobile"
            name="mobile"
            onFocus={numberWheelChange}
            className="form-control form-control-lg"
            placeholder="Enter a valid mobile number"
            onInput={(e) => {
              if (e.target.value.length > 10) {
                e.target.value = e.target.value.slice(0, 10);
              }
            }}
            {...register("mobile", {
              required: "This is required.",
              pattern: {
                value: /^[0-9]{10}$/i,
                message: "invalid mobile number",
              },
            })}
          />
          {errors.mobile && <ErrorLabel message={errors.mobile?.message} />}
        </div>
        <div className="d-flex justify-content-between">
          <div class="col-12">
            <div class="form-check">


              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <input class="form-check-input" type="checkbox" id="is_accepted_terms" defaultChecked
                    {...register("is_accepted_terms", {
                      required: "Please accept Terms and Conditions"
                    })} />

                  <label class="form-check-label" for="is_accepted_terms">
                    <a data-bs-toggle="modal" data-bs-target="#exampleModal" className="text-primary">
                      Accept T&C
                    </a>
                  </label>
                </div>
                <label class="form-check-label" for="faq">
                  <a href="#" class="text-primary" data-bs-toggle="modal" data-bs-target="#faqModal">
                    FAQ
                  </a>
                </label>
              </div>


              <div class="modal fade" id="faqModal" tabindex="-1" aria-labelledby="faqModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="faqModalLabel">FAQ</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="form-check-label" for="is_accepted_terms">
                          <a href="/documents/Any_user_New_Personal_Vehicle.pdf" target="_blank" class="text-primary">
                            Any new user pesonal vehicle
                          </a>
                        </label>

                        <label class="form-check-label" for="is_accepted_terms">
                          <a href="/documents/Employee login- Existing_Renewal.pdf" target="_blank" class="text-primary">
                            Employee login - Existing Renewal
                          </a>
                        </label>

                        <label class="form-check-label" for="is_accepted_terms">
                          <a href="/documents/New User_New_Corporate_Vehicle.pdf" target="_blank" class="text-primary">
                            New User new corporate vehicles
                          </a>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>




            </div>
            {errors.is_accepted_terms && <ErrorLabel message={errors.is_accepted_terms?.message} />}
          </div>

        </div>
        <div className="text-center text-lg-start mt-4">
          <button type="submit" className="btn btn-primary w-100"   disabled={props.isDisabled}>
            Get OTP
          </button>
          <div className="text-center mt-2">
            Don't have an Account ?
            <a
              onClick={() => {
                props.handleRegistration();
              }}
              className="text-primary text-decoration-underline ms-1"
            >
              Register Now
            </a>
          </div>
          <div className="my-2 text-center">
            OR
          </div>
          <div className="text-center">
            <a href="employer/login" className="text-primary text-decoration-underline" >
              Admin Login
            </a>
          </div>
        </div>
        <TermsConditions />
      </form>
    </>
  );
};

export default EnterEmailMobile;
